import request from '../tools/request'
import { HTTP } from './http'
import { pages } from './Params'
const { GET, POST } = request

interface productmanager extends pages {
  name?: string // 名称
}
// 分页获取产品经理列表
export const GET_PRODUCTMANAGER_LIST = (params: productmanager) =>
  GET(`${HTTP}/productManager/getProductManagerPage`, params)

interface AccountParams {
  name?: string // 姓名
  mobile?: string // 手机号码
  mail?: string // 员工编号
  pageNo: number
  pageSize: number
  supplierId: string
  schemeId?: string // 搜索方案id
}

// 多条件查询账号列表
export const GET_EMPUSERLIST = (params: AccountParams) =>
  GET(`${HTTP}/supplierUser/getSupplierUserPage`, params)

// 获取员工角色授权信息
export const GET_USERROLEDATA = () => GET(`${HTTP}/emptouser/getUserRole`)

interface EmpParams extends pages {
  loginManCreateCode?: string // 登入人创建组织
  empName?: string // 姓名
  empPhone?: string // 联系方式
  empNumber?: string // 编码
  empCreateCode?: string // 创建组织编码
  empUseCode?: string // 使用组织编码
  empMail?: string // 邮箱
  isFirstJob?: string // 主任岗位
  pushState?: string // 推送状态
  banState?: string // 禁用状态
}
// 员工多条件查询
export const GET_EMPLIST = (params: EmpParams) =>
  GET(`${HTTP}/emp/getEmp`, params)

interface EmpJobParams {
  deptid: string // 部门id
  pushState: 1 // 已推送的
}
// 获取就任岗位
export const EMP_JOBLIST = (params: EmpJobParams) =>
  GET(`${HTTP}/job/listByDeptId`, params)

// 获取单位组
export const GET_UNIT_GROUP = () =>
  GET(`${HTTP}/materageunit/benchmarklist`, { type: '1' })

// 删除账号
export const DEL_USER = (params: { params: string[] }) =>
  POST(
    `${HTTP}/supplierUser/deleteSupplierUserById`,
    params,
    'application/json',
  )

interface ADDSUPPLIERUSER {
  mail: string
  mobile: string
  realName: string
  supplierId: string
}
// 新增账号信息
export const ADD_SUPPLIERUSER = (params: ADDSUPPLIERUSER) =>
  POST(`${HTTP}/supplierUser/addSupplierUser`, params, 'application/json')

// 重置密码
export const UPDATE_PASSWORD = (params: { params: string[] }) =>
  POST(
    `${HTTP}/supplierUser/updatePasswordBySupplierUserIds`,
    params,
    'application/json',
  )

// 移交管理员
export const ADMIN_TRANSFER = (params: {
  id: string
  supplierUserId: string
}) =>
  POST(
    `${HTTP}/supplierUser/transferAdminBySupplierUserId`,
    params,
    'application/json',
  )

// 个人中心
export const GET_USERINFO = (params: { supplierUserId: string }) =>
  GET(`${HTTP}/supplierUser/getSupplierUserById`, params)

interface UPDATE_USERPASS {
  confirmNewPassword: string
  newPassword: string
  originalPassword: string
  supplierUserId: string
}
// 重置密码---个人中心
export const UPDATE_USERPASSWORD = (params: UPDATE_USERPASS) =>
  POST(
    `${HTTP}/supplierUser/updatePasswordBySupplierUserId`,
    params,
    'application/json',
  )

// 获取收款信息
export const GET_FINANCIAL_LIST = (params: { supplierId: string }) =>
  GET(`${HTTP}/financial/getFinancialDTOList`, params)
import request from '../tools/request'
import { HTTP } from './http'
import { pages } from './Params'
const { GET, POST } = request

interface productmanager extends pages {
  name?: string // 名称
}
// 分页获取产品经理列表
export const GET_PRODUCTMANAGER_LIST = (params: productmanager) =>
  GET(`${HTTP}/productManager/getProductManagerPage`, params)

interface AccountParams {
  name?: string // 姓名
  mobile?: string // 手机号码
  mail?: string // 员工编号
  pageNo: number
  pageSize: number
  supplierId: string
  schemeId?: string // 搜索方案id
}

// 多条件查询账号列表
export const GET_EMPUSERLIST = (params: AccountParams) =>
  GET(`${HTTP}/supplierUser/getSupplierUserPage`, params)

// 获取员工角色授权信息
export const GET_USERROLEDATA = () => GET(`${HTTP}/emptouser/getUserRole`)

interface EmpParams extends pages {
  loginManCreateCode?: string // 登入人创建组织
  empName?: string // 姓名
  empPhone?: string // 联系方式
  empNumber?: string // 编码
  empCreateCode?: string // 创建组织编码
  empUseCode?: string // 使用组织编码
  empMail?: string // 邮箱
  isFirstJob?: string // 主任岗位
  pushState?: string // 推送状态
  banState?: string // 禁用状态
}
// 员工多条件查询
export const GET_EMPLIST = (params: EmpParams) =>
  GET(`${HTTP}/emp/getEmp`, params)

interface EmpJobParams {
  deptid: string // 部门id
  pushState: 1 // 已推送的
}
// 获取就任岗位
export const EMP_JOBLIST = (params: EmpJobParams) =>
  GET(`${HTTP}/job/listByDeptId`, params)

// 获取单位组
export const GET_UNIT_GROUP = () =>
  GET(`${HTTP}/materageunit/benchmarklist`, { type: '1' })

// 删除账号
export const DEL_USER = (params: { params: string[] }) =>
  POST(
    `${HTTP}/supplierUser/deleteSupplierUserById`,
    params,
    'application/json',
  )

interface ADDSUPPLIERUSER {
  mail: string
  mobile: string
  realName: string
  supplierId: string
}
// 新增账号信息
export const ADD_SUPPLIERUSER = (params: ADDSUPPLIERUSER) =>
  POST(`${HTTP}/supplierUser/addSupplierUser`, params, 'application/json')

// 重置密码
export const UPDATE_PASSWORD = (params: { params: string[] }) =>
  POST(
    `${HTTP}/supplierUser/updatePasswordBySupplierUserIds`,
    params,
    'application/json',
  )

// 移交管理员
export const ADMIN_TRANSFER = (params: {
  id: string
  supplierUserId: string
}) =>
  POST(
    `${HTTP}/supplierUser/transferAdminBySupplierUserId`,
    params,
    'application/json',
  )

// 个人中心
export const GET_USERINFO = (params: { supplierUserId: string }) =>
  GET(`${HTTP}/supplierUser/getSupplierUserById`, params)

interface UPDATE_USERPASS {
  confirmNewPassword: string
  newPassword: string
  originalPassword: string
  supplierUserId: string
}
// 重置密码---个人中心
export const UPDATE_USERPASSWORD = (params: UPDATE_USERPASS) =>
  POST(
    `${HTTP}/supplierUser/updatePasswordBySupplierUserId`,
    params,
    'application/json',
  )

// 获取收款信息
export const GET_FINANCIAL_LIST = (params: { supplierId: string }) =>
  GET(`${HTTP}/financial/getFinancialDTOList`, params)
